import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/auth/forgot-password/page.tsx");
